module.exports = "https://www.gc-qa.gnp.com.mx/d437ca66a7c53d60775569f6429f82a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-poliza-gm.svg
// module id = 8085
// module chunks = 0